import type { UseFetchOptions } from "nuxt/app";
import { useLogger } from "./useLogger";
import { useApiService } from "./useApiService";

export interface DeleteUserRequest {
  authIds: string[];
}

export interface DeleteUserResponse {
  success: boolean;
  version: number;
  message: string;
  deletedCount: number;
  environment: string;
  timestamp: string;
  process: {
    type: string;
    nodeVersion: string;
    platform: string;
  };
}

export function useDeleteUserService() {
  const logger = useLogger();
  const { makeApiCall, forceTestVsTestServer } = useApiService();

  const deleteUsers = async (
    authIds: string[],
    options?: UseFetchOptions<DeleteUserResponse>,
  ) => {
    logger.debug("DeleteUserService: Deleting users", { authIds });

    const deleteRequest: DeleteUserRequest = {
      authIds,
    };

    return makeApiCall<DeleteUserRequest, DeleteUserResponse>(
      "auth/delete-users",
      deleteRequest,
      "DeleteUserService",
      options
    );
  };

  const deleteTestUser = async (
    authId: string,
    forceTestVsTestServerInput = false,
  ) => {
    forceTestVsTestServer.value = forceTestVsTestServerInput;
    const deleteRequest: DeleteUserRequest = {
      authIds: [authId],
    };
    return makeApiCall<DeleteUserRequest, DeleteUserResponse>(
      "auth/delete-users",
      deleteRequest,
      "DeleteUserService"
    );
  };

  return {
    forceTestVsTestServer,
    deleteUsers,
    deleteTestUser,
  };
}
